import React, { useState } from 'react';
import { Box } from '@mui/material';
import SchedulePage from "../components/SchedulePage"

const Schedule = () => {
    return (
        <SchedulePage />

    );
};

export default Schedule;
